import { useContext } from "react";

import LaunchDarklyContext from "./launchDarklyProvider";

export const useParentLDContext = () => {
  const LDContext = useContext(LaunchDarklyContext);

  return LDContext;
};
